export interface TagAttrs {
  clickable?: boolean;
  icon?: string;
  removable?: boolean;
  size?: TagSize;
  'tag-name': string;
  theme?: TagTheme;
}

export enum TagTheme {
  Dark = `dark`,
  Light = `light`,
  Invalid = `invalid`,
  Secondary = `secondary`,
}

export enum TagSize {
  Small = `small`,
  Default = `default`,
}
